import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import qs from 'query-string';
import config from '../../config';
// import '../../resources/css/test.css';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationTotalTableV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            loading:true,
            theData:[],
            total:0,
            theTable:null,
            tableHead:[],
            tableBody:[],
            tableFooter:[],
            height:props.height,
            maxHeight:props.maxHeight
      };
    }

    formatNumber(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    async loadOut(){
        let formData;
        let qResp;
        let qData;
        
        let qWhere="1=1";
        let url=config.apiv2.registrationStage;
        let theData=[];
        let total=0;
        let tableHead=[];
        let tableBody=[];
        let tableFooter=[];


        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","Priority_Category");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            tableHead.push(<th key={1}>Phase</th>)
            tableBody.push(<td key={69}>Distributution</td>)
            tableFooter.push(<td key={70}></td>)
            _.forEach(qData.features,function(value,key){
                // console.log(value.attributes);
                total+=value.attributes.total;
                theData.push({
                    name: value.attributes.Priority_Category,
                    type: 'bar',
                    data: [value.attributes.total]
                });
                // let test = this.formatNumber(value.attributes.total)
                // console.log()
                tableHead.push(<th key={value.attributes.Priority_Category}>{value.attributes.Priority_Category}</th>)
                
                
            });
            
            for (const [key,value] of Object.entries(theData)){ 
                let percCalc=(value.data[0]/total)*100;
                percCalc=Math.round(percCalc * 10) / 10
                console.log(percCalc)
                tableBody.push(<td key={value.data[0]}>{percCalc}%</td>)
                tableFooter.push(<td key={value.data[0]+1}>{this.formatNumber(value.data[0])}</td>)

            }
            // _.forEach(theData,function(value,key){
            //     let percCalc=(value.data[0]/total)*100;
            //     percCalc=Math.round(percCalc * 10) / 10
            //     console.log(percCalc)
            //     tableBody.push(<td key={value.data[0]}>{percCalc}%</td>)
            //     tableFooter.push(<td key={value.data[0]+1}>{this.formatNumber(total)value.data[0]}</td>)
            // });
            
            tableHead.push(<th key="Total">Total</th>)
            tableBody.push(<td key="0"></td>)
            tableFooter.push(<td key={total}>{this.formatNumber(total)}</td>)

            this.setState({
                loading:false,
                total:this.formatNumber(total),
                // theData:theData,
                tableHead:tableHead,
                tableBody:tableBody,
                tableFooter:tableFooter,
                error:false,
            });
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }


    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <Table striped bordered hover size="sm" responsive style={{fontSize:"10pt",height:this.state.height}}>
                    <thead>
                        <tr style={{backgroundColor:"#b63a3a",color:"#FFFFFF"}}>
                            {this.state.tableHead}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {this.state.tableBody}
                        </tr>
                        <tr>
                            {this.state.tableFooter}
                        </tr>
                    </tbody>
                </Table>
            );
        }
    }
}

export default RegistrationTotalTableV2;